export default __webpack_public_path__ + "efaaa2b135fc8bcba1f02c93718d6fa8.png";